import {ReactElement, useState} from "react"
import {Avatar, ConfigProvider, List} from "antd"
import {observer} from "mobx-react-lite"
import classNames from "classnames"
import {t} from "@ui/common/intl"
import {useStore} from "@ui/stores"
import SwipePanel, {SwipePanelHeight} from "@ui/components/services/common/SwipePanel"
import EyeIcon from "@ui/icons/track/Eye"
import EyeOffIcon from "@ui/icons/track/EyeOff"
import {TLayerPageProps} from "./"

const Main = ({close, isShow}: TLayerPageProps): ReactElement => {
  const {poi: {categories}, layer} = useStore()
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    close()
  }

  const handleClick = (code: string) => {
    layer.toggle(code)
    setLoading(loading => !loading)
  }

  return isShow
    ? (
      <SwipePanel
        onClose={handleClose}
        onSwipe={close}
        className="main"
        height={SwipePanelHeight.FULL}
        header={
          <>
            <span className="title">{t("layers.main.title")}</span>
          </>
        }
      >
        <ConfigProvider>
            <List
              dataSource={categories || []}
              renderItem={({code}, i) => (
                <List.Item
                  key={`layer-${code}-${i}`}
                  onClick={() => handleClick(code)}
                  actions={[
                    layer.has(code) ? <EyeIcon/> : <EyeOffIcon/>
                  ]}
                >
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        src={`/poi/${code}.svg`}
                        shape="circle"
                        className={classNames("icon", code)}
                      />
                    }
                    title={<span className="primary-text">{t(`poi.category.${code}`)}</span>}
                  />
                </List.Item>
              )}
            />
          </ConfigProvider>
      </SwipePanel>
    )
    : (<></>)
}

export default observer(Main)
